import {
    createContext,
    useContext,
    useEffect
} from "react";
import type {
    TraceCollapsibleContextType,
    TraceInteractiveContextType,
    TraceContextType
} from "./type";
import {
    warnOnce
} from "../../utils/development";

export const TraceContext = createContext<TraceContextType | undefined>(undefined);

export const TraceCollapsibleContext = createContext<TraceCollapsibleContextType | undefined>(undefined);

export const TraceInteractiveContext = createContext<TraceInteractiveContextType>({
    isInteractive: false,
    isActive: false
});

export const useTraceCollapsibleContext = ({
    part
}: {
    part: string;
}): TraceCollapsibleContextType | undefined => {
    const context = useContext(TraceCollapsibleContext);

    useEffect(() => {
        if(context) {
            return;
        }

        warnOnce({
            message: `Trace.${part}: must be rendered inside <Trace.Collapsible>.`
        });
    }, [
        context,
        part
    ]);

    return context;
};
